import { useDeviceType } from '@cian/ui-kit/responsive';
import { useSelector } from 'react-redux';

import { useIsOfferCardPage } from './useIsOfferCardPage';
import { MOBILE_SEARCH_STRING_AND_FF_EXPERIMENT } from '../constants/experiments';
import { selectExperiments } from '../selectors/experiments';
import { selectPageType } from '../selectors/page';
import { TPageType } from '../types/page';
import { isExperimentActive } from '../utils/experiments';

const SEARCH_PAGE_TYPES: TPageType[] = ['search', 'searchRentDaily'];

/**
 * Эксперимент со строкой поиска в шапке на мобильной выдаче.
 * В тестовой группе шапка визуально объединяется со строкой поиска, поэтому линия под шапкой не нужна.
 *
 * На карточке объявления строки поиска нет, поэтому линия должна вернуться.
 * SPA-переходы выдача <-> карточка отслеживает useIsOfferCardPage.
 */
export function useIsMobileSearchStringExperiment(): boolean {
  const experiments = useSelector(selectExperiments);
  const pageType = useSelector(selectPageType);
  const deviceType = useDeviceType();
  const isOfferCardPage = useIsOfferCardPage();

  return (
    deviceType !== 'desktop' &&
    SEARCH_PAGE_TYPES.includes(pageType) &&
    !isOfferCardPage &&
    isExperimentActive(experiments, MOBILE_SEARCH_STRING_AND_FF_EXPERIMENT, 'B')
  );
}
